import React from 'react';
import { Route, Link } from 'react-router-dom';

import { avangaEncodeURI, valideCSSName } from './../helpers';

// 3rd Party
import Collapse from 'react-collapse';

class PressFull extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      index: props.index,
      items: props.items,
      itemsPerRow: props.itemsPerRow,
      nextDivisible: (props.index % props.itemsPerRow === 0) ? props.index : (Math.round(props.index / props.itemsPerRow) * props.itemsPerRow) - 1,
      total: props.items.length
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      index: nextProps.index,
      items: nextProps.items,
      itemsPerRow: nextProps.itemsPerRow,
      nextDivisible: ((nextProps.index + 1) % nextProps.itemsPerRow === 0) ? nextProps.index : (Math.round(nextProps.index / nextProps.itemsPerRow) * nextProps.itemsPerRow) - 1,
      total: nextProps.items.length
    });
  }

  render() {
    if (((this.state.index + 1) % this.state.itemsPerRow === 0) || (this.state.total % this.state.itemsPerRow !== 0 && this.state.index + 1 === this.state.total)) {
      return (
        <section className="press-full">
          {this.state.items.map((item, index) => {
            if ((index <= this.state.index) && (index >= (this.state.nextDivisible - (this.state.itemsPerRow - 1)))) {
              return (
                <Route path={`/presse/${valideCSSName(avangaEncodeURI(item.subline_hover))}`} children={({ match }) => (
                  <Collapse isOpened={match}>
                    <section className={`press-article-full ${avangaEncodeURI(item.subline_hover)}`}>
                      <Link to="/" className="read-more">
                        <svg id="Ebene_1" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 100 100">
                          <g>
                            <path d="M50,5A45,45,0,1,0,95,50,45,45,0,0,0,50,5ZM77,54.75H54.75V77a4.76,4.76,0,1,1-9.5,0V54.75H23a4.76,4.76,0,1,1,0-9.5H45.25V23a4.76,4.76,0,1,1,9.5,0V45.25H77a4.76,4.76,0,1,1,0,9.5Z"/>
                          </g>
                        </svg>
                      </Link>
                      <h2>{item.heading}</h2>
                      <div className="subline" dangerouslySetInnerHTML={{ __html: item.subline }} />
                      <div className="download-wrap">
                        <div className="file-name">{item.file}</div>
                        <a href={`/public/content/assets/${item.file}`}>Artikel anzeigen</a>
                      </div>
                    </section>
                  </Collapse>
                )} />
              );
            }
          })}
        </section>
      );
    }

    return false;
  }
}

export default PressFull;


// WEBPACK FOOTER //
// ./src/sections/press/press-full.jsx